import type { ClientEvent, ClientEventType } from '@/types/database';

export type { ClientEvent, ClientEventType };

export type TimelineCategory =
  | 'contact_phone'
  | 'contact_email'
  | 'contact_whatsapp'
  | 'meeting'
  | 'milestone'
  | 'note'
  | 'document_upload'
  | 'transaction_created';

export interface TimelineItem {
  id: string;
  category: TimelineCategory;
  title: string;
  description?: string | null;
  date: Date;
  authorName?: string | null;
  // Para eventos manuais (permite editar/excluir)
  manualEventId?: string;
  // Links opcionais para origem
  documentId?: string;
  transactionId?: string;
}

export const CATEGORY_LABELS: Record<TimelineCategory, string> = {
  contact_phone: 'Ligação',
  contact_email: 'E-mail',
  contact_whatsapp: 'WhatsApp',
  meeting: 'Reunião',
  milestone: 'Marco',
  note: 'Anotação',
  document_upload: 'Documento',
  transaction_created: 'Transação',
};

export const CATEGORY_COLORS: Record<TimelineCategory, string> = {
  contact_phone: 'bg-blue-100 text-blue-700 border-blue-200',
  contact_email: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  contact_whatsapp: 'bg-green-100 text-green-700 border-green-200',
  meeting: 'bg-purple-100 text-purple-700 border-purple-200',
  milestone: 'bg-amber-100 text-amber-700 border-amber-200',
  note: 'bg-gray-100 text-gray-700 border-gray-200',
  document_upload: 'bg-teal-100 text-teal-700 border-teal-200',
  transaction_created: 'bg-orange-100 text-orange-700 border-orange-200',
};

export const MANUAL_EVENT_TYPES: ClientEventType[] = [
  'contact_phone',
  'contact_email',
  'contact_whatsapp',
  'meeting',
  'milestone',
  'note',
];

export interface TimelineFilters {
  categories: TimelineCategory[]; // empty = todas
  fromDate: string;
  toDate: string;
}

function startOfCurrentMonthIso(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  return `${yyyy}-${mm}-01`;
}

/**
 * Default = mês corrente. Reduz volume retornado pelo Postgres em datasets grandes
 * e cobre o caso típico (ver atividade recente). Para abrir tudo, usuário limpa data.
 */
export function getDefaultTimelineFilters(): TimelineFilters {
  return {
    categories: [],
    fromDate: startOfCurrentMonthIso(),
    toDate: '',
  };
}

export function isDefaultTimelineFilters(f: TimelineFilters): boolean {
  return f.categories.length === 0 && f.fromDate === startOfCurrentMonthIso() && f.toDate === '';
}

export const EMPTY_TIMELINE_FILTERS: TimelineFilters = {
  categories: [],
  fromDate: '',
  toDate: '',
};
